import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material'
import { useBulkPaymentStepperContext } from '../../contexts/BulkPaymentStepperContext'
import BigStatCurrency from '../BigStatCurrency'
import { NameWithFavicon } from '../NameWithFavicon'
import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import { Success } from './Success'

export default function BulkPaymentStepper() {
  const { activeStep, vendorId, vendor, paymentTotal } = useBulkPaymentStepperContext()

  return (
    <Box>
      <Stepper activeStep={activeStep}>
        <Step completed={vendorId !== undefined}>
          <StepLabel>
            {activeStep > 0 && vendor ? (
              <Box display="flex" flexDirection="column" mt="0.8rem">
                <NameWithFavicon name={vendor.name} website={vendor.website} />
                <Typography variant="caption" sx={{ pl: '28px', mt: -0.5 }}>
                  Outstanding: {vendor.outstandingCommission}
                </Typography>
              </Box>
            ) : (
              'Select Vendor'
            )}
          </StepLabel>
        </Step>
        <Step completed={typeof paymentTotal !== 'undefined' && paymentTotal > 0}>
          <StepLabel>
            {activeStep > 1 && paymentTotal ? (
              <Box display="flex" flexDirection="column">
                <Typography variant="caption">Payment Total</Typography>
                <BigStatCurrency value={paymentTotal} sx={{ fontSize: '1.5em' }} />
              </Box>
            ) : (
              'Payment Total'
            )}
          </StepLabel>
        </Step>
        <Step>
          <StepLabel>Allocate</StepLabel>
        </Step>
      </Stepper>
      <Box my={4}>
        {activeStep === 0 && <Step1 />}
        {activeStep === 1 && <Step2 />}
        {activeStep === 2 && <Step3 />}
        {activeStep === 4 && <Success />}
      </Box>
    </Box>
  )
}
